import React from 'react'

import { aiLogoSvg } from './svgs'

export interface AiLogoProps {
  fill?: string
  height?: number
  width?: number
  children?: React.ReactNode
}

export const AiLogo: React.FC<AiLogoProps> = ({
  fill = '#413573',
  height = 28,
  width = 32,
  children
}) => (
  <svg
    aria-labelledby='ai-logo'
    role='img'
    viewBox='0 0 32 28'
    height={height}
    width={width}
    fill={fill}
  >
    <title id='ai-logo'>AI</title>
    {children}
    {aiLogoSvg.map(svg => (
      <path {...svg} key={svg.d} />
    ))}
  </svg>
)
